// import {createRouter, createWebHistory} from "vue-router";
import {createRouter, createWebHashHistory} from "vue-router";

import NotFound from '../views/NotFound'
// const Home = () => import('../views/Home')
import Home from '../views/Home'
// const Home = { template: "<div>Home</div>" };
// const About = () => import('../views/About')

const router =  createRouter({
    // history: createWebHistory(),
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name:'Home',
            component: Home
            // component: () => import('@/views/Home')
        },
        {
            path: '/about',
            // component: About
            component: () => import('../views/About')
        },
        {
            path: '/contact',
            // component: Contact
            component: () => import('../views/Contact')
        },
        {
            path:'/:path(.*)',
            component: NotFound
        }
    ]
});

export default router;